/* eslint-disable max-len */
import React, { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import ButtonComp from '../../component/Common/Button/Button.view';
import HeaderComp from '../../component/Common/Header/Header';
import Pagination from '../../component/Common/Pagination/Pagination.view';
import TabsTable from '../../component/Common/Tabs_Table';
import { FlexContainer } from '../../globalStyles';
import { apiEndPoints } from '../../services/axios/endPoints';
import { ActivityCreators } from './store';
import PaginationWithPage from '../../component/Common/Pagination/PaginationWithPage.view';
import { fetchUserAndLocation } from '../../component/Sidenav/fetchPageStatistics';

const rowOptions = [
  { id: 1, label: 'Edit', value: 'edit' }
  // { id: 2, label: 'Delete', value: 'delete' }
];

const Activity = () => {
  const {
    loading,
    error,
    searchQueries,
    activityData,
    activityColumn,
    activityCount,
    activityListMeta
  } = useSelector((state) => state.activityData);
  const data = useSelector((state) => state.activityData);

  const dispatch = useDispatch();
  const pageSize = 20;
  const lang = 'en';

  const saveSearchQueries = (payload) => {
    dispatch(ActivityCreators.setSearchQueries(payload));
  };

  const handlePageChange = (page) => {
    const endpoint = apiEndPoints.getActivity;
    dispatch(
      ActivityCreators.getActivity({
        page,
        pageSize,
        endpoint,
        lang,
        searchQueries
      })
    );
  };

  useEffect(() => {
    handlePageChange(1);
  }, []);

  useEffect(() => {
    handlePageChange(1);
  }, [searchQueries]);

  const navigate = useNavigate();
  const handleShowDetails = (rowItem) => {
    navigate('/home/activity/details', {
      state: { details: rowItem, columns: activityColumn?.columns }
    });
  };

  const handleDelete = async (rowItem) => {
    const { activityId } = rowItem;
  };
  const handleRowOptionsItemClick = (opt, addParams) => {
    const { activeRowItem } = addParams;
    if (opt.value === 'edit') {
      navigate('/home/activity/edit', { state: { detail: activeRowItem } });
    } else if (opt.value === 'delete') {
      handleDelete(activeRowItem);
    }
  };

  const handleCreateActivity = () => {
    navigate('create');
  };

  const { userData } = useSelector((state) => state.loginData);
  const { finalMenu } = useSelector((state) => state.home);
  const location = useLocation();
  useEffect(() => {
    const name = finalMenu.find((ele) => ele.path === location.pathname);
    fetchUserAndLocation(location.pathname, userData, {
      pageType: name?.name
    });
  }, []);

  return (
    <>
      <HeaderComp hasBack={false} header='Activity'>
        <FlexContainer>
          <ButtonComp dark margin='0rem 2rem' onClick={handleCreateActivity}>
            + Create Activity
          </ButtonComp>
          <PaginationWithPage
            ItemsPerPage={pageSize}
            total={activityColumn?.count}
            handlePageChange={handlePageChange}
            searchParams={searchQueries}
          />
        </FlexContainer>
      </HeaderComp>
      <TabsTable
        className='noBorder'
        handlePageChange={handlePageChange}
        handleTabSelect={() => {}}
        pageSize={pageSize}
        metaDetails={activityColumn}
        dataDetails={activityData}
        assetListLoading={loading}
        onItemSelect={handleShowDetails}
        showShortlistSelection={false}
        showPagiation={false}
        saveSearchQueries={saveSearchQueries}
        savedSearchQueries={searchQueries}
        resetSearchQueries={saveSearchQueries}
        error={error}
        rowOptions={rowOptions}
        handleRowOptionsItemClick={handleRowOptionsItemClick}
        id='activityId'
      />
    </>
  );
};

export default Activity;
